<template lang="pug">
  section
    b-container
      h1 ORDERS
      b-form-group(label="SHOW")
        b-form-checkbox-group(:options="statusOptions", text-field="text", value-field="value", v-model="filter.type", switches, @input="getOrders()")
      content-loader(:height="7", v-if="alert.loading")
      div(v-else-if="orders && orders.length > 0")
        b-card.table-card
          p(v-if='orders.length < 1') No orders
          b-table(v-else="", hover, :items="orders", :fields="fields", @row-clicked="openRow", :per-page="10", :current-page="currentPage", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
            template(v-slot:cell(compTotal)="row") {{ formatRands(row.item.total) }}
            template(v-slot:cell(compType)="row")
              b-badge() {{ row.item.type }}
            template(v-slot:cell(compStatus)="row")
              b-badge(:variant="row.item.shipment_status==='completed'?'dark':'light'") {{ row.item.status }}
        b-pagination.mt-2(v-model="currentPage", :total-rows="totalRows", :per-page="10", size="sm", align="right")
      nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Order',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      orders: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'compType', label: 'Type' },
        { key: 'created_pretty', label: 'Date', sortable: true },
        { key: 'customer_name', label: 'Customer' },
        // { key: 'compTotal', label: 'Total' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
      statusOptions: ['sale', 'rental', 'renewal', 'conversion'],
      filter: {
        type: ['sale', 'rental', 'renewal', 'conversion'],
      },
    };
  },
  computed: {
    totalRows() {
      return this.orders.length;
    },
  },
  methods: {
    async getOrders() {
      this.loading();
      this.orders = await apiService.getOrders(this.filter);
      this.clear();
    },
    openRow(row) {
      router.push({ name: 'Order', params: { orderId: row.id } });
    },
  },
  async created() {
    this.loading();
    this.orders = await apiService.getOrders(this.filter);
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Orders.vue